import { useParams, Navigate } from "react-router-dom";
import { OffrePage } from "../components/offres/OffrePage";
import { OFFRES } from "../offres";

export default function Offre() {
  const { slug } = useParams();
  const offre = OFFRES[slug];
  if (!offre) return <Navigate to="/catalogue?cat=Solutions%20hospitali%C3%A8res%20propos%C3%A9es" replace />;
  return <OffrePage key={slug} offre={offre} />;
}
